import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import TopBar from './components/TopBar';

import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/SEO';

// Page Components
import Hero from './components/Hero';
import Services from './components/Services';
import Shop from './components/Shop';
import Achievements from './components/Achievements';

// Elite Page Multi-page Components
import AboutPage from './pages/AboutPage';
import ProgramsPage from './pages/Programs';
import CommunityPage from './pages/Community';
import PartnersPage from './pages/Partners';
import ContactPage from './pages/Contact';
import SessionsPage from './pages/SessionsPage';

// Scroll Management
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Layout Wrappers
const Home = () => (
  <main>
    <SEO
      title="Home"
      description="Vision Sports Academy in Harare, Zimbabwe. Training the next generation of sports champions with elite coaching and world-class facilities."
    />
    <Hero />
    <Achievements />
    <Services />
    <section className="section bg-primary text-center">
      <div className="container">
        <h2 className="text-5xl font-black mb-8 uppercase">Join Vision Sports <br /><span className="text-secondary">Academy Today</span></h2>
        <p className="text-muted mb-12 max-w-xl mx-auto">Take the first step towards athletic excellence and provincial selection. Our elite coaches are ready for you.</p>
        <a
          href="https://wa.me/263781665264?text=Hi, I would like to register my child for Vision Sports Academy sessions."
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary btn-large"
        >
          Register Your Child
        </a>
      </div>
    </section>
    <Shop limit={3} />
  </main>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App selection:bg-secondary selection:text-primary">
          <TopBar />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/academy" element={<ProgramsPage />} />
            <Route path="/shop" element={<main className="pt-20"><Shop /></main>} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/sessions" element={<SessionsPage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
